if(process.env.REACT_APP_NODE_ENV==='PROD') console.log = function() {};